import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import HeaderSection from "./headerSection";
import { useTranslation } from "react-i18next";

interface SidebarProps {
  isOpen?: boolean;
  onToggleSidebar: () => void;
}

const Sidebar: React.FC<SidebarProps> = ({ isOpen, onToggleSidebar }) => {

  const { t } = useTranslation();

  const location = useLocation();
  
  const [isReportsOpen, setIsReportsOpen] = useState(true);

  return (
    <>
      <HeaderSection onToggleSidebar={onToggleSidebar} />

      {/* Sidebar */}
      <div style={{ ...styles.sidebar, width: isOpen ? "260px" : "60px" }}>

        <ul style={styles.navLinks}>
          {/* Reports Dropdown */}
          <li
            style={styles.navItem}
            onClick={() => setIsReportsOpen(!isReportsOpen)}
          >
            <span style={styles.icon}>📌</span>
            {isOpen && <span style={styles.text}>{t('Sidebar.Reports')}</span>}
          </li>
          {isReportsOpen && isOpen && (
            <ul style={styles.dropdownMenu}>
              <li style={location.pathname === "/"? styles.selectedNavItem: styles.navItem }>
                <Link to="/" style={styles.link}>
                  <span style={styles.icon}>📄</span>
                  <span style={styles.text}>{t('Sidebar.New Origination Summary')}</span>
                </Link>
              </li>

              <li style={location.pathname === "/NewOriginationByBranchState"? styles.selectedNavItem: styles.navItem }>
                <Link to="/NewOriginationByBranchState" style={styles.link}>
                  <span style={styles.icon}>📄</span>
                  <span style={styles.text}>{t('Sidebar.New Origination By Branch State')}</span>
                </Link>
              </li>

              <li style={location.pathname === "/portfolioOverall"? styles.selectedNavItem: styles.navItem }>
                <Link to="/portfolioOverall" style={styles.link}>
                  <span style={styles.icon}>📄</span>
                  <span style={styles.text}>{t('Sidebar.Portfolio Summary Overall')}</span>
                </Link>
              </li>

              <li style={location.pathname === "/portfolioSummaryEWI"? styles.selectedNavItem: styles.navItem }>
                <Link to="/portfolioSummaryEWI" style={styles.link}>
                  <span style={styles.icon}>📄</span>
                  <span style={styles.text}>{t('Sidebar.Portfolio Summary - EWI')}</span>
                </Link>
              </li>

              <li style={location.pathname === "/deliquencyRatesEWI"? styles.selectedNavItem: styles.navItem }>
                <Link to="/deliquencyRatesEWI" style={styles.link}>
                  <span style={styles.icon}>📄</span>
                  <span style={styles.text}>{t('Sidebar.Portfolio Delinquency - EWI')}</span>
                </Link>
              </li>

              <li style={location.pathname === "/portfolioSummaryEWIKerala"? styles.selectedNavItem: styles.navItem }>
                <Link to="/portfolioSummaryEWIKerala" style={styles.link}>
                  <span style={styles.icon}>📄</span>
                  <span style={styles.text}>{t('Sidebar.Kerala MI - EWI')}</span>
                </Link>
              </li>

              <li style={location.pathname === "/portfolioSummaryEWITamilNadu"? styles.selectedNavItem: styles.navItem }>
                <Link to="/portfolioSummaryEWITamilNadu" style={styles.link}>
                  <span style={styles.icon}>📄</span>
                  <span style={styles.text}>{t('Sidebar.TamilNadu MI - EWI')}</span>
                </Link>
              </li>

              <li style={location.pathname === "/vintageReportOverallFirst"? styles.selectedNavItem: styles.navItem }>
                <Link to="/vintageReportOverallFirst" style={styles.link}>
                  <span style={styles.icon}>📄</span>
                  <span style={styles.text}>{t('Sidebar.# Vintage Report Overall')}</span>
                </Link>
              </li>

              <li style={location.pathname === "/vintageReportOverallSecond"? styles.selectedNavItem: styles.navItem }>
                <Link to="/vintageReportOverallSecond" style={styles.link}>
                  <span style={styles.icon}>📄</span>
                  <span style={styles.text}>{t('Sidebar.₹ Vintage Report Overall')}</span>
                </Link>
              </li>

              <li style={location.pathname === "/thirtyPlusDelinquency"? styles.selectedNavItem: styles.navItem }>
                <Link to="/thirtyPlusDelinquency" style={styles.link}>
                  <span style={styles.icon}>📄</span>
                  <span style={styles.text}>{t('Sidebar.Count 30+ Coincidental')}</span>
                </Link>
              </li>

              <li style={location.pathname === "/thirthyPlusPerDelinquency"? styles.selectedNavItem: styles.navItem }>
                <Link to="/thirthyPlusPerDelinquency" style={styles.link}>
                  <span style={styles.icon}>📄</span>
                  <span style={styles.text}>{t('Sidebar.%30+ Coincidental')}</span>
                </Link>
              </li>

              <li style={location.pathname === "/newOriginationByProductType"? styles.selectedNavItem: styles.navItem }>
                <Link to="/newOriginationByProductType" style={styles.link}>
                  <span style={styles.icon}>📄</span>
                  <span style={styles.text}>{t('Sidebar.New Origination Product')}</span>
                </Link>
              </li>

              <li style={location.pathname === "/ticketSizeByBranch"? styles.selectedNavItem: styles.navItem }>
                <Link to="/ticketSizeByBranch" style={styles.link}>
                  <span style={styles.icon}>📄</span>
                  <span style={styles.text}>{t('Sidebar.Ticket Size By Branch')}</span>
                </Link>
              </li>

              <li style={location.pathname === "/flowRatesByBranch"? styles.selectedNavItem: styles.navItem }>
                <Link to="/flowRatesByBranch" style={styles.link}>
                  <span style={styles.icon}>📄</span>
                  <span style={styles.text}>{t('Sidebar.Flow Rates - EWI')}</span>
                </Link>
              </li>

              <li style={location.pathname === "/flowRatesKerala"? styles.selectedNavItem: styles.navItem }>
                <Link to="/flowRatesKerala" style={styles.link}>
                  <span style={styles.icon}>📄</span>
                  <span style={styles.text}>{t('Sidebar.Flow Rates Kerala - EWI')}</span>
                </Link>
              </li>

              <li style={location.pathname === "/flowRatesTamilNadu"? styles.selectedNavItem: styles.navItem }>
                <Link to="/flowRatesTamilNadu" style={styles.link}>
                  <span style={styles.icon}>📄</span>
                  <span style={styles.text}>{t('Sidebar.Flow Rates Tamil Nadu - EWI')}</span>
                </Link>
              </li>

              <li style={location.pathname === "/productOfFlows"? styles.selectedNavItem: styles.navItem }>
                <Link to="/productOfFlows" style={styles.link}>
                  <span style={styles.icon}>📄</span>
                  <span style={styles.text}>{t('Sidebar.Product Of Flows - EWI')}</span>
                </Link>
              </li>

              <li style={location.pathname === "/productOfFlowsKerala"? styles.selectedNavItem: styles.navItem }>
                <Link to="/productOfFlowsKerala" style={styles.link}>
                  <span style={styles.icon}>📄</span>
                  <span style={styles.text}>{t('Sidebar.Flows Kerala- EWI')}</span>
                </Link>
              </li>

              <li style={location.pathname === "/productOfFlowsTamilNadu"? styles.selectedNavItem: styles.navItem }>
                <Link to="/productOfFlowsTamilNadu" style={styles.link}>
                  <span style={styles.icon}>📄</span>
                  <span style={styles.text}>{t('Sidebar.Flows TamilNadu - EWI')}</span>
                </Link>
              </li>

              <li style={location.pathname === "/wasIs"? styles.selectedNavItem: styles.navItem }>
                <Link to="/wasIs" style={styles.link}>
                  <span style={styles.icon}>📄</span>
                  <span style={styles.text}>{t('Sidebar.Was-ls')}</span>
                </Link>
              </li>

              <li style={location.pathname === "/ttdDla"? styles.selectedNavItem: styles.navItem }>
                <Link to="/ttdDla" style={styles.link}>
                  <span style={styles.icon}>📄</span>
                  <span style={styles.text}>{t('Sidebar.TTD DLA')}</span>
                </Link>
              </li>

              <li style={location.pathname === "/colending"? styles.selectedNavItem: styles.navItem }>
                <Link to="/colending" style={styles.link}>
                  <span style={styles.icon}>📄</span>
                  <span style={styles.text}>{t('Sidebar.Co-lending')}</span>
                </Link>
              </li>

              <li style={location.pathname === "/telecalling"? styles.selectedNavItem: styles.navItem }>
                <Link to="/telecalling" style={styles.link}>
                  <span style={styles.icon}>📄</span>
                  <span style={styles.text}>{t('Sidebar.TeleCalling')}</span>
                </Link>
              </li>

              <li style={location.pathname === "/deliquencyEmi"? styles.selectedNavItem: styles.navItem }>
                <Link to="/deliquencyEmi" style={styles.link}>
                  <span style={styles.icon}>📄</span>
                  <span style={styles.text}>{t('Sidebar.Portfolio Delinquency - EMI')}</span>
                </Link>
              </li>
              <li style={location.pathname === "/flowRatesEmi"? styles.selectedNavItem: styles.navItem }>
                <Link to="/flowRatesEmi" style={styles.link}>
                  <span style={styles.icon}>📄</span>
                  <span style={styles.text}>{t('Sidebar.Flow Rates By Branch EMI')}</span>
                </Link>
              </li>
              <li style={location.pathname === "/keralaMiEmi"? styles.selectedNavItem: styles.navItem }>
                <Link to="/keralaMiEmi" style={styles.link}>
                  <span style={styles.icon}>📄</span>
                  <span style={styles.text}>{t('Sidebar.Kerala Mi - EMI')}</span>
                </Link>
              </li>
              <li style={location.pathname === "/portfolioSummaryEMI"? styles.selectedNavItem: styles.navItem }>
                <Link to="/portfolioSummaryEMI" style={styles.link}>
                  <span style={styles.icon}>📄</span>
                  <span style={styles.text}>{t('Sidebar.Portfolio Summary - EMI')}</span>
                </Link>
              </li>
              <li style={location.pathname === "/tamilNaduEMI"? styles.selectedNavItem: styles.navItem }>
                <Link to="/tamilNaduEMI" style={styles.link}>
                  <span style={styles.icon}>📄</span>
                  <span style={styles.text}>{t('Sidebar.TamilNadu - EMI')}</span>
                </Link>
              </li>

            </ul>
          )}
        </ul>
      </div>
    </>
  );
};

const styles: { [key: string]: React.CSSProperties } = {
  sidebar: {
    height: "100vh",
    backgroundColor: "#2c3e50",
    color: "#fff",
    padding: "5px",
    display: "flex",
    flexDirection: "column",
    position: "fixed",
    left: 0,
    top: "30px",  // Adjusted to ensure it's below the KPB header
    transition: "width 0.3s ease-in-out",
    overflowX: "hidden",
    zIndex: 2,
  },
  toggleBtn: {
    backgroundColor: "#34495e",
    color: "#fff",
    border: "none",
    cursor: "pointer",
    padding: "10px",
    fontSize: "14px",
    width: "100%",
    textAlign: "center",
  },
  navLinks: {
    listStyle: "none",
    padding: 0,
    marginTop: "20px",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
  },
  navItem: {
    display: "flex",
    alignItems: "center",
    padding: "10px",
    cursor: "pointer",
    width: "100%",
    transition: "background 0.2s",
  },
  selectedNavItem: {
    display: "flex",
    alignItems: "center",
    padding: "10px",
    cursor: "pointer",
    width: "100%",
    transition: "background 0.2s",
    backgroundColor: "#778da9",
  },
  link: {
    textDecoration: "none",
    color: "#ecf0f1",
    display: "flex",
    alignItems: "center",
    width: "100%",
  },
  icon: {
    marginRight: "10px",
    fontSize: "14px",
  },
  text: {
    whiteSpace: "nowrap",
    fontSize: "13px"
  },
  dropdownMenu: { 
    listStyle: "none",
    paddingLeft: "20px",
    paddingBottom: "25px"
  } as React.CSSProperties, 
};

const styleshead: { [key: string]: React.CSSProperties } = {
  kpbHeader: {
    backgroundColor: "white",  // Background color if needed
    padding: "10px",           // Adjust padding as necessary
    display: "flex",
    alignItems: "center",      // Align vertically in the center
    justifyContent: "space-between",  // Optional: spread out image and toggle bar
  },
  headerImage: {
    width: "100px",          // Adjust width as needed (e.g., 100px)
    height: "auto",          // Maintain aspect ratio
    objectFit: "contain",    // Ensures the image scales without distortion
  },
  toggleBar: {
    cursor: "pointer",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    width: "30px",           // Width for the toggle bar
    height: "20px",          // Height for the toggle bar container
  },
  // Add other styles for toggle-bar lines and other elements as needed
};
export default Sidebar;
